import { render, staticRenderFns } from "./StockTrfPrintDetails_Company.vue?vue&type=template&id=71d48015&"
import script from "./StockTrfPrintDetails_Company.vue?vue&type=script&lang=js&"
export * from "./StockTrfPrintDetails_Company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports